import { Link } from "react-router-dom";
import { toast } from "sonner";
import { svcPath } from "./services";

export function ServiceTile({ s, size = "md" }) {
  const body = (
    <>
      <span className={`relative grid h-[68px] w-full place-items-center rounded-2xl border border-slate-200 bg-white text-[#0F2C47] shadow-[0_1px_2px_rgba(15,44,71,0.06)] ${s.soon ? "opacity-50" : ""}`}>
        <s.icon className="h-7 w-7" strokeWidth={1.7} />
        {s.soon && <span className="absolute -right-1 -top-1.5 rounded-full bg-[#F26B1D] px-1.5 text-[8px] font-extrabold text-white">SOON</span>}
      </span>
      <span className={`min-h-[28px] text-[11px] font-medium leading-tight ${s.soon ? "text-slate-400" : "text-slate-700"}`}>{s.label}</span>
    </>
  );
  const cls = "flex flex-col items-center gap-1.5 text-center transition-transform active:scale-95";
  if (s.soon) return <button type="button" className={cls} onClick={() => toast("Yeh service jald aa rahi hai")} data-testid={`m-svc-${s.key}`}>{body}</button>;
  return <Link to={svcPath(s)} className={cls} data-testid={`m-svc-${s.key}`}>{body}</Link>;
}
